<template>
    <div>
        <template v-if="items.length">
            <v-container>
                <h3>Eerder gescand</h3>
            </v-container>
            <v-list>
                <v-list-tile ripple v-for="item in items" :key="item.product.barcode" @click="infoModalItem = item">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.count }} &times; {{ item.product.name || item.product.barcode }}
                        </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn icon @click="deleteItem(item)">
                            <v-icon color="danger">
                                delete
                            </v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </template>
        <v-container v-else>
            <p>Scan de streepjescode van een voedingsproduct zoals een pak koffie, melk of koekjes om er meer informatie over te zien.</p>
            <p>Bron productinformatie: <a href="https://www.thequestionmark.org/" target="_blank">Questionmark</a></p>
        </v-container>

        <v-btn fab fixed bottom right icon dark color="primary" @click="showScanModal = true" v-if="!modalOpen">
            <v-icon>add</v-icon>
        </v-btn>

        <v-dialog v-model="showScanModal" fullscreen scrollable>
            <scan-screen @close="showScanModal = false" @add="onScanAdd" v-if="showScanModal" />
        </v-dialog>

        <v-dialog :value="!!infoModalItem" @input="infoModalItem = null" fullscreen scrollable>
            <info-screen @close="infoModalItem = null" @delete="deleteItem(infoModalItem)" v-if="infoModalItem" :product="infoModalItem.product" />
        </v-dialog>
    </div>
</template>

<script>
import ScanScreen from './BarcodeShopper/ScanScreen'
import InfoScreen from './BarcodeShopper/InfoScreen'

export default {
    components: {
        ScanScreen,
        InfoScreen,
    },
    data () {
        return {
            items: [],
            showScanModal: false,
            infoModalItem: null,
        }
    },
    computed: {
        modalOpen () {
            return this.showScanModal || this.infoModalItem
        },
    },
    methods: {
        onScanAdd (product) {
            const itemIndex = this.items.findIndex((item) => {
                return item.product.barcode === product.barcode
            })

            let item
            if (itemIndex >= 0) {
                item = this.items[itemIndex]
                this.items.splice(itemIndex, 1)
            } else {
                item = {
                    product,
                    count: 0,
                }
            }

            item.count++

            this.items.unshift(item)
        },
        deleteItem (deleteItem) {
            const itemIndex = this.items.findIndex((item) => {
                return deleteItem.code === item.code
            })

            if (itemIndex >= 0) {
                this.items.splice(itemIndex, 1)
            }
        },
    },
}
</script>

<style scoped>
.v-btn--floating {
    z-index: 1999;
}
</style>
